export const Icons = ({ testid = '', className = '', color = '', variant, onClick = () => {} }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.UPLOAD: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_50254_335257)">
              <path
                d="M5.83452 14C4.79475 14 3.79757 13.6049 3.06234 12.9016C2.32711 12.1984 1.91406 11.2446 1.91406 10.25C1.91406 9.25544 2.32711 8.30161 3.06234 7.59835C3.79757 6.89509 4.79475 6.5 5.83452 6.5C6.08009 5.40598 6.79849 4.44457 7.83167 3.82726C8.34326 3.5216 8.91672 3.30962 9.51933 3.20343C10.1219 3.09723 10.7419 3.0989 11.3438 3.20833C11.9457 3.31777 12.5177 3.53283 13.0273 3.84123C13.5368 4.14964 13.9739 4.54535 14.3135 5.00577C14.6531 5.4662 14.8886 5.98232 15.0066 6.52466C15.1246 7.06701 15.1228 7.62496 15.0012 8.16667H15.8345C16.6081 8.16667 17.3499 8.47396 17.8969 9.02094C18.4439 9.56792 18.7512 10.3098 18.7512 11.0833C18.7512 11.8569 18.4439 12.5987 17.8969 13.1457C17.3499 13.6927 16.6081 14 15.8345 14H15.0012"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.5 11.5L10 9L12.5 11.5"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 9V16.5"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_50254_335257">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.PRE_APPROVAL: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.8968 10.1387C27.9399 7.55792 24.0601 7.55792 22.1032 10.1387C21.0354 11.5469 19.291 12.2695 17.5402 12.0288C14.3316 11.5876 11.5881 14.3311 12.0293 17.5397C12.27 19.2905 11.5474 21.0349 10.1392 22.1027C7.55841 24.0596 7.55841 27.9394 10.1392 29.8963C11.5474 30.9641 12.27 32.7085 12.0293 34.4593C11.5881 37.668 14.3315 40.4114 17.5402 39.9703C19.291 39.7295 21.0354 40.4521 22.1032 41.8603C24.0601 44.4411 27.9399 44.4411 29.8968 41.8603C30.9646 40.4521 32.709 39.7295 34.4598 39.9703C37.6685 40.4114 40.4119 37.668 39.9707 34.4593C39.73 32.7085 40.4526 30.9641 41.8608 29.8963C44.4416 27.9394 44.4416 24.0596 41.8608 22.1027C40.4526 21.0349 39.73 19.2905 39.9707 17.5397C40.4119 14.3311 37.6685 11.5876 34.4598 12.0288C32.709 12.2695 30.9646 11.5469 29.8968 10.1387ZM33.4564 22.8707C34.2134 22.0664 34.1751 20.8006 33.3707 20.0436C32.5664 19.2866 31.3006 19.3249 30.5436 20.1293L23.9565 27.1281L21.4142 24.5858C20.6332 23.8047 19.3668 23.8047 18.5858 24.5858C17.8047 25.3668 17.8047 26.6332 18.5858 27.4142L22.5858 31.4142C22.9683 31.7967 23.4894 32.008 24.0303 31.9998C24.5712 31.9916 25.0857 31.7646 25.4564 31.3707L33.4564 22.8707Z"
                fill="#00B152"
              />
            </g>
          </svg>
        );
      }
      case Icons.ARCHIVE: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.8099 14.82C18.1783 14.82 17.613 15.2118 17.3912 15.8031L15.1335 21.8241L20.4325 21.8241C21.2982 21.8241 22 22.5259 22 23.3916C22 25.1126 23.3873 26.5119 25.1083 26.5266L26.8283 26.5413C28.5756 26.5562 30 25.1439 30 23.3965C30 22.5281 30.704 21.8241 31.5724 21.8241H36.8661L34.6084 15.8031C34.3867 15.2118 33.8214 14.82 33.1898 14.82H18.8099ZM13.9863 14.5264C14.7403 12.5157 16.6625 11.1836 18.8099 11.1836H33.1898C35.3372 11.1836 37.2594 12.5157 38.0133 14.5264L42.5286 26.5684C42.72 27.0787 42.818 27.6192 42.818 28.1643V36.0031C42.818 38.8482 40.5116 41.1546 37.6665 41.1546H14.3332C11.4881 41.1546 9.18164 38.8482 9.18164 36.0031V28.1643C9.18164 27.6192 9.27966 27.0787 9.47101 26.5684L13.9863 14.5264Z"
              fill="#747475"
            />
          </svg>
        );
      }
      case Icons.BACK: {
        return (
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="1" y="1" width="42" height="42" rx="21" fill="white" />
            <rect x="1" y="1" width="42" height="42" rx="21" stroke="#E8E9EA" strokeWidth="2" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.694 28.6943C26.102 28.2867 26.102 27.6259 25.694 27.2184L20.4699 22L25.694 16.7817C26.102 16.3741 26.102 15.7133 25.694 15.3057C25.2859 14.8981 24.6244 14.8981 24.2164 15.3057L18.306 21.2096C18.0886 21.4267 17.987 21.7158 18.0013 22.0002C17.9871 22.2844 18.0887 22.5733 18.306 22.7904L24.2164 28.6943C24.6244 29.1019 25.286 29.1019 25.694 28.6943Z"
              fill="#515151"
            />
          </svg>
        );
      }
      case Icons.TRANSACTION: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 6.99984H18M18 6.99984L14.5 3.5M18 6.99984L14.5 10.5"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18 16.9987H5M5 16.9987L8.49935 13.5M5 16.9987L8.5 20.4987"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.INSURANCE: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.00048 5.5L12.0001 3L18.9999 5.5C20.4999 18 13.0002 20.5 12.0001 20.5C11 20.5 3.49989 18 5.00048 5.5Z"
              stroke="#747475"
              strokeWidth="2"
            />
          </svg>
        );
      }
      case Icons.TAXES: {
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 20.001H7.5C6.39543 20.001 5.5 19.1055 5.5 18.001V6C5.5 4.89543 6.39543 4 7.5 4H13.5858C13.851 4 14.1054 4.10536 14.2929 4.29289L18.2071 8.20711C18.3946 8.39464 18.5 8.649 18.5 8.91421V11.5"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.5 4V7C13.5 8.10457 14.3954 9 15.5 9H18.5"
              stroke="#747475"
              strokeWidth="2"
            />
            <circle cx="17.5" cy="17" r="5.25" stroke="#747475" strokeWidth="2" />
            <path
              d="M18.85 15.5C18.85 15.5 18.4 15 17.5 15C16.6 15 16.15 15.5 16.15 16C16.15 17.25 19 16.6 19 18C19 18.6 18.5 19 17.5 19C16.5 19 16 18.4 16 18.4"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.5 14V20"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.FINANCIAL: {
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12.5" cy="12" r="9" stroke="#747475" strokeWidth="2" />
            <path
              d="M15.2 8.625C15.2 8.625 14.3 7.5 12.5 7.5C10.7 7.5 9.8 8.625 9.8 9.75C9.8 12.5625 15.5 11.1 15.5 14.25C15.5 15.6 14.5 16.5 12.5 16.5C10.5 16.5 9.5 15.15 9.5 15.15"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.5 6V18"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.MISC_2: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                d="M41 22.8798V35C41 38.866 37.866 42 34 42H23C21.3431 42 20 40.6569 20 39C20 38.7239 20.2239 38.5 20.5 38.5H32.5C35.2614 38.5 37.5 36.2614 37.5 33.5V19.5871C37.5 19.1599 38.0011 18.9295 38.3254 19.2075L39.9524 20.602C40.6173 21.172 41 22.004 41 22.8798Z"
                fill="#51BFE1"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 12C12.5 9.51472 14.5147 7.5 17 7.5H26.7574C27.9508 7.5 29.0954 7.97411 29.9393 8.81802L34.182 13.0607C35.0259 13.9046 35.5 15.0492 35.5 16.2426V32C35.5 34.4853 33.4853 36.5 31 36.5H17C14.5147 36.5 12.5 34.4853 12.5 32V12Z"
                fill="#51BFE1"
              />
            </g>
          </svg>
        );
      }
      case Icons.DOCUMENT_SOLID: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 43.0028H10C8.89543 43.0028 8 42.1074 8 41.0028V12.5742C8 10.9174 9.34315 9.57422 11 9.57422H28.1429C29.7997 9.57422 31.1429 10.9174 31.1429 12.5742V41.0028C31.1429 42.1074 30.2474 43.0028 29.1429 43.0028H24.5714C23.4669 43.0028 22.5714 42.1074 22.5714 41.0028V38.0028C22.5714 37.4505 22.1237 37.0028 21.5714 37.0028H18C17.4477 37.0028 17 37.4505 17 38.0028V41.0028C17 42.1074 16.1046 43.0028 15 43.0028ZM15 15.5742C14.4477 15.5742 14 16.0219 14 16.5742V18.4314C14 18.9836 14.4477 19.4314 15 19.4314H16.8571C17.4094 19.4314 17.8571 18.9836 17.8571 18.4314V16.5742C17.8571 16.0219 17.4094 15.5742 16.8571 15.5742H15ZM15 22.0028C14.4477 22.0028 14 22.4505 14 23.0028V24.8599C14 25.4122 14.4477 25.8599 15 25.8599H16.8571C17.4094 25.8599 17.8571 25.4122 17.8571 24.8599V23.0028C17.8571 22.4505 17.4094 22.0028 16.8571 22.0028H15ZM14 29.4314C14 28.8791 14.4477 28.4314 15 28.4314H16.8571C17.4094 28.4314 17.8571 28.8791 17.8571 29.4314V31.2885C17.8571 31.8408 17.4094 32.2885 16.8571 32.2885H15C14.4477 32.2885 14 31.8408 14 31.2885V29.4314ZM22.2857 15.5742C21.7334 15.5742 21.2857 16.0219 21.2857 16.5742V18.4314C21.2857 18.9836 21.7334 19.4314 22.2857 19.4314H24.1429C24.6951 19.4314 25.1429 18.9836 25.1429 18.4314V16.5742C25.1429 16.0219 24.6951 15.5742 24.1429 15.5742H22.2857ZM21.2857 23.0028C21.2857 22.4505 21.7334 22.0028 22.2857 22.0028H24.1429C24.6951 22.0028 25.1429 22.4505 25.1429 23.0028V24.8599C25.1429 25.4122 24.6951 25.8599 24.1429 25.8599H22.2857C21.7334 25.8599 21.2857 25.4122 21.2857 24.8599V23.0028ZM22.2857 28.4314C21.7334 28.4314 21.2857 28.8791 21.2857 29.4314V31.2885C21.2857 31.8408 21.7334 32.2885 22.2857 32.2885H24.1429C24.6951 32.2885 25.1429 31.8408 25.1429 31.2885V29.4314C25.1429 28.8791 24.6951 28.4314 24.1429 28.4314H22.2857Z"
                fill={color}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.7129 42.9978H41.9986C43.1032 42.9978 43.9986 42.1024 43.9986 40.9979V22.2087C43.9986 21.0356 43.3149 19.9702 42.2486 19.4815L34.9272 16.1258C34.3594 15.8656 33.7129 16.2805 33.7129 16.905V40.9979C33.7129 42.1024 34.6083 42.9978 35.7129 42.9978ZM38.1415 22.4264C37.5892 22.4264 37.1415 22.8741 37.1415 23.4264V24.855C37.1415 25.4073 37.5892 25.855 38.1415 25.855H39.57C40.1223 25.855 40.57 25.4073 40.57 24.855V23.4264C40.57 22.8741 40.1223 22.4264 39.57 22.4264H38.1415ZM37.1415 29.4264C37.1415 28.8741 37.5892 28.4264 38.1415 28.4264H39.57C40.1223 28.4264 40.57 28.8741 40.57 29.4264V30.855C40.57 31.4073 40.1223 31.855 39.57 31.855H38.1415C37.5892 31.855 37.1415 31.4073 37.1415 30.855V29.4264ZM38.1415 34.4264C37.5892 34.4264 37.1415 34.8741 37.1415 35.4264V36.855C37.1415 37.4073 37.5892 37.855 38.1415 37.855H39.57C40.1223 37.855 40.57 37.4073 40.57 36.855V35.4264C40.57 34.8741 40.1223 34.4264 39.57 34.4264H38.1415Z"
                fill={color}
              />
            </g>
          </svg>
        );
      }
      case Icons.LEGAL: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.5 19V20C4.05228 20 4.5 19.5523 4.5 19H3.5ZM9.5 19H8.5C8.5 19.5523 8.94772 20 9.5 20V19ZM10 20.0909V21.4545H12V20.0909H10ZM10.4545 21H2.54546V23H10.4545V21ZM3 21.4545V20.0909H1V21.4545H3ZM3.09091 20H3.5V18H3.09091V20ZM9.5 20H9.90909V18H9.5V20ZM4.5 19V18.5455H2.5V19H4.5ZM4.04545 19H8.95455V17H4.04545V19ZM8.5 18.5455V19H10.5V18.5455H8.5ZM8.95455 19C8.70351 19 8.5 18.7965 8.5 18.5455H10.5C10.5 17.6919 9.80808 17 8.95455 17V19ZM2.54546 21C2.79649 21 3 21.2035 3 21.4545H1C1 22.3081 1.69193 23 2.54546 23V21ZM10 21.4545C10 21.2035 10.2035 21 10.4545 21V23C11.3081 23 12 22.3081 12 21.4545H10ZM4.5 18.5455C4.5 18.7965 4.29649 19 4.04545 19V17C3.19192 17 2.5 17.6919 2.5 18.5455H4.5ZM12 20.0909C12 18.9361 11.0639 18 9.90909 18V20C9.9593 20 10 20.0407 10 20.0909H12ZM3 20.0909C3 20.0407 3.0407 20 3.09091 20V18C1.93613 18 1 18.9361 1 20.0909H3Z"
              fill="#747475"
            />
            <path
              d="M12 11L13.9995 9.00049L22.2285 17.2286C22.6546 17.6546 22.6546 18.3454 22.2286 18.7714L21.7714 19.2286C21.3454 19.6546 20.6546 19.6546 20.2286 19.2286L12 11Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5 9.5L12.5 4.5L15.5 7.5L10.5 12.5L7.5 9.5Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.2714 4.27139C11.8454 3.84536 11.8454 3.15464 12.2714 2.72861L12.7286 2.27139C13.1546 1.84536 13.8454 1.84536 14.2714 2.27139L17.7286 5.72861C18.1546 6.15464 18.1546 6.84536 17.7286 7.27139L17.2714 7.72861C16.8454 8.15464 16.1546 8.15464 15.7286 7.72861L12.2714 4.27139Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.27139 11.2714C4.84536 10.8454 4.84536 10.1546 5.27139 9.72861L5.72861 9.27139C6.15464 8.84536 6.84536 8.84536 7.27139 9.27139L10.7286 12.7286C11.1546 13.1546 11.1546 13.8454 10.7286 14.2714L10.2714 14.7286C9.84536 15.1546 9.15464 15.1546 8.72861 14.7286L5.27139 11.2714Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.MAINTENANCE: {
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_49455_151603)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.29781 2.8848C8.52528 2.39317 9.86687 2.25914 11.1673 2.49824C12.4678 2.73733 13.674 3.33977 14.6463 4.23584C15.6187 5.13191 16.3174 6.28498 16.6617 7.56164C17.006 8.83829 16.9818 10.1863 16.5918 11.4498L20.9858 15.1678C21.3816 15.5042 21.7034 15.9189 21.931 16.3858C22.1585 16.8527 22.2869 17.3617 22.3079 17.8807C22.3289 18.3997 22.2422 18.9174 22.0532 19.4012C21.8642 19.885 21.577 20.3244 21.2097 20.6917C20.8424 21.059 20.403 21.3462 19.9192 21.5352C19.4354 21.7242 18.9177 21.8109 18.3987 21.7899C17.8797 21.7689 17.3707 21.6405 16.9038 21.413C16.4369 21.1854 16.0222 20.8636 15.6858 20.4678L11.9688 16.0738C10.7052 16.4639 9.35704 16.4882 8.08024 16.1439C6.80344 15.7995 5.65025 15.1007 4.75414 14.1282C3.85802 13.1557 3.25562 11.9493 3.01665 10.6487C2.77768 9.34804 2.91191 8.00632 3.40381 6.7788C3.76181 5.8848 4.88381 5.7718 5.46681 6.4058L8.66981 9.8838L10.1158 9.5958L10.4058 8.1468L6.92581 4.9488C6.29181 4.3658 6.40281 3.2428 7.29781 2.8848ZM9.30481 4.4208L12.0678 6.9608C12.3898 7.2568 12.5338 7.6988 12.4478 8.1258L11.9778 10.4798C11.9294 10.7221 11.8103 10.9445 11.6355 11.1191C11.4607 11.2937 11.2381 11.4126 10.9958 11.4608L8.64581 11.9278C8.43549 11.9696 8.21795 11.9566 8.0141 11.8901C7.81025 11.8235 7.62694 11.7057 7.48181 11.5478L4.93781 8.7858C4.83426 9.64594 4.95589 10.5182 5.29079 11.3172C5.62568 12.1163 6.16237 12.8146 6.84827 13.3438C7.53418 13.8731 8.34579 14.2151 9.20361 14.3364C10.0614 14.4577 10.9361 14.3541 11.7418 14.0358C11.9862 13.9388 12.2548 13.9209 12.5099 13.9846C12.765 14.0483 12.9937 14.1903 13.1638 14.3908L17.2138 19.1768C17.3709 19.3632 17.565 19.5149 17.7837 19.6224C18.0025 19.7298 18.2412 19.7907 18.4847 19.801C18.7283 19.8114 18.9713 19.7711 19.1984 19.6826C19.4255 19.5942 19.6318 19.4595 19.8041 19.2871C19.9765 19.1148 20.1112 18.9085 20.1996 18.6814C20.2881 18.4543 20.3284 18.2112 20.318 17.9677C20.3077 17.7242 20.2468 17.4855 20.1394 17.2667C20.0319 17.0479 19.8802 16.8539 19.6938 16.6968L14.9088 12.6468C14.7084 12.4767 14.5663 12.248 14.5026 11.9929C14.4389 11.7378 14.4568 11.4692 14.5538 11.2248C14.8724 10.419 14.9763 9.54433 14.8551 8.68638C14.7339 7.82843 14.3919 7.01667 13.8626 6.33068C13.3333 5.64469 12.6348 5.10799 11.8356 4.77318C11.0365 4.43837 10.164 4.31694 9.30381 4.4208H9.30481Z"
                fill="#747475"
              />
            </g>
            <defs>
              <clipPath id="clip0_49455_151603">
                <rect width="24" height="24" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.MISC: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.33301 5.66601C5.33301 4.56145 6.22844 3.66602 7.33301 3.66602H13.8011C14.0702 3.66602 14.328 3.77448 14.5161 3.9669L18.3813 7.92C18.564 8.10685 18.6663 8.35779 18.6663 8.61912V18.3327C18.6663 19.4373 17.7709 20.3327 16.6663 20.3327H7.33301C6.22844 20.3327 5.33301 19.4373 5.33301 18.3327V5.66601Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.667 3.66602V6.66602C13.667 7.77059 14.5624 8.66602 15.667 8.66602H18.667"
              stroke="#747475"
              strokeWidth="2"
            />
          </svg>
        );
      }
      case Icons.DOTS: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="6" cy="12" r="2" fill="#747475" />
            <circle cx="12" cy="12" r="2" fill="#747475" />
            <circle cx="18" cy="12" r="2" fill="#747475" />
          </svg>
        );
      }
      case Icons.SHARE: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.66667 2.81683V5.33398C4.70909 5.33398 2.4197 7.55823 2.05242 11.7528C2.01847 12.1405 2.52009 12.3161 2.78368 12.0298C4.29635 10.387 6.12167 9.66732 8.66667 9.66732L8.66667 12.5178C8.66667 12.696 8.8821 12.7852 9.00809 12.6592L13.7172 7.95016C13.8734 7.79395 13.8734 7.54068 13.7172 7.38447L9.00809 2.67541C8.8821 2.54941 8.66667 2.63865 8.66667 2.81683Z"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.DOWNLOAD: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.66699 11.332V12.6654C2.66699 13.019 2.80747 13.3581 3.05752 13.6082C3.30757 13.8582 3.6467 13.9987 4.00033 13.9987H12.0003C12.3539 13.9987 12.6931 13.8582 12.9431 13.6082C13.1932 13.3581 13.3337 13.019 13.3337 12.6654V11.332"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.66699 7.33203L8.00033 10.6654L11.3337 7.33203"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 2.66797V10.668"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.EDIT: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.66797 13.3322H5.33464L12.3346 6.33223C12.6883 5.97861 12.8869 5.499 12.8869 4.9989C12.8869 4.4988 12.6883 4.01919 12.3346 3.66557C11.981 3.31194 11.5014 3.11328 11.0013 3.11328C10.5012 3.11328 10.0216 3.31194 9.66797 3.66557L2.66797 10.6656V13.3322Z"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 4.33203L11.6667 6.9987"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.DELETE: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.66797 4.66602H13.3346"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.66797 7.33398V11.334"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.33203 7.33398V11.334"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.33203 4.66602L3.9987 12.666C3.9987 13.0196 4.13917 13.3588 4.38922 13.6088C4.63927 13.8589 4.97841 13.9993 5.33203 13.9993H10.6654C11.019 13.9993 11.3581 13.8589 11.6082 13.6088C11.8582 13.3588 11.9987 13.0196 11.9987 12.666L12.6654 4.66602"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 4.66667V2.66667C6 2.48986 6.07024 2.32029 6.19526 2.19526C6.32029 2.07024 6.48986 2 6.66667 2H9.33333C9.51014 2 9.67971 2.07024 9.80474 2.19526C9.92976 2.32029 10 2.48986 10 2.66667V4.66667"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.TABLE_VIEW: {
        return (
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="1" y="1" width="42" height="42" rx="21" fill="white" />
            <rect x="1" y="1" width="42" height="42" rx="21" stroke="#E8E9EA" strokeWidth="2" />
            <circle cx="14.5" cy="16" r="2" fill="#515151" />
            <circle cx="14.5" cy="22" r="2" fill="#515151" />
            <circle cx="14.5" cy="28" r="2" fill="#515151" />
            <path
              d="M20 16H30"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 22H30"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 28H30"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.GRID_VIEW: {
        return (
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="1" y="1" width="42" height="42" rx="21" fill="white" />
            <rect x="1" y="1" width="42" height="42" rx="21" stroke="#E8E9EA" strokeWidth="2" />
            <rect x="13" y="15" width="7" height="5" rx="1" stroke="#515151" strokeWidth="2" />
            <rect x="13" y="24" width="7" height="5" rx="1" stroke="#515151" strokeWidth="2" />
            <rect x="24" y="24" width="7" height="5" rx="1" stroke="#515151" strokeWidth="2" />
            <rect x="24" y="15" width="7" height="5" rx="1" stroke="#515151" strokeWidth="2" />
          </svg>
        );
      }
      case Icons.DOCUMENT_1: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="#F4F5F6" />
            <path
              d="M9.3335 9.66601C9.3335 8.56145 10.2289 7.66602 11.3335 7.66602H17.8016C18.0707 7.66602 18.3284 7.77448 18.5166 7.9669L22.3818 11.92C22.5645 12.1068 22.6668 12.3578 22.6668 12.6191V22.3327C22.6668 23.4373 21.7714 24.3327 20.6668 24.3327H11.3335C10.2289 24.3327 9.3335 23.4373 9.3335 22.3327V9.66601Z"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.6665 7.66602V10.666C17.6665 11.7706 18.5619 12.666 19.6665 12.666H22.6665"
              stroke="#515151"
              strokeWidth="2"
            />
          </svg>
        );
      }
      case Icons.DOCUMENT_2: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect opacity="0.09" width="32" height="32" rx="16" fill="#747475" />
            <path
              d="M18 7V11C18 11.2652 18.1054 11.5196 18.2929 11.7071C18.4804 11.8946 18.7348 12 19 12H23"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 25H11C10.4696 25 9.96086 24.7893 9.58579 24.4142C9.21071 24.0391 9 23.5304 9 23V9C9 8.46957 9.21071 7.96086 9.58579 7.58579C9.96086 7.21071 10.4696 7 11 7H18L23 12V23C23 23.5304 22.7893 24.0391 22.4142 24.4142C22.0391 24.7893 21.5304 25 21 25Z"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 13H14"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 17H19"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 21H19"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.DOCUMENT_3: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 9H10"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 13H15"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 17H15"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.VIEW: {
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.5 12.6671C3.41212 12.1405 4.44678 11.8633 5.5 11.8633C6.55322 11.8633 7.58788 12.1405 8.5 12.6671C9.41212 12.1405 10.4468 11.8633 11.5 11.8633C12.5532 11.8633 13.5879 12.1405 14.5 12.6671"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.5 3.99916C3.41212 3.47255 4.44678 3.19531 5.5 3.19531C6.55322 3.19531 7.58788 3.47255 8.5 3.99916C9.41212 3.47255 10.4468 3.19531 11.5 3.19531C12.5532 3.19531 13.5879 3.47255 14.5 3.99916"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.5 4V12.6667"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.5 4V12.6667"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.5 4V12.6667"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.SHARE_APP_MSG: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect opacity="0.12" width="32" height="32" rx="16" fill="#51BFE1" />
            <path
              d="M10.3189 19.3824L11.239 19.7741L11.4368 19.3094L11.1803 18.8744L10.3189 19.3824ZM9.02865 22.4127L9.94872 22.8044H9.94872L9.02865 22.4127ZM9.66865 23.0751L9.30873 22.1421H9.30873L9.66865 23.0751ZM12.8561 21.8454L13.3382 20.9693L12.9304 20.7449L12.4962 20.9124L12.8561 21.8454ZM21.7321 16.0007C21.7321 19.1303 19.195 21.6673 16.0654 21.6673V23.6673C20.2996 23.6673 23.7321 20.2348 23.7321 16.0007H21.7321ZM16.0654 10.334C19.195 10.334 21.7321 12.871 21.7321 16.0007H23.7321C23.7321 11.7665 20.2996 8.33398 16.0654 8.33398V10.334ZM10.3988 16.0007C10.3988 12.871 12.9358 10.334 16.0654 10.334V8.33398C11.8312 8.33398 8.39875 11.7665 8.39875 16.0007H10.3988ZM11.1803 18.8744C10.6838 18.0326 10.3988 17.0515 10.3988 16.0007H8.39875C8.39875 17.4185 8.78456 18.7493 9.45754 19.8904L11.1803 18.8744ZM9.94872 22.8044L11.239 19.7741L9.39883 18.9906L8.10858 22.0209L9.94872 22.8044ZM9.30873 22.1421C9.72103 21.983 10.1218 22.3978 9.94872 22.8044L8.10858 22.0209C7.58921 23.2407 8.79166 24.4852 10.0286 24.008L9.30873 22.1421ZM12.4962 20.9124L9.30873 22.1421L10.0286 24.008L13.216 22.7784L12.4962 20.9124ZM16.0654 21.6673C15.0748 21.6673 14.1463 21.414 13.3382 20.9693L12.374 22.7215C13.47 23.3246 14.7292 23.6673 16.0654 23.6673V21.6673Z"
              fill="#51BFE1"
            />
          </svg>
        );
      }
      default:
        return null;
    }
  };
  return (
    <div testid={testid} onClick={onClick} className={className} style={{ display: 'flex' }}>
      {renderIcon()}
    </div>
  );
};

Icons.UPLOAD = 'upload';
Icons.PRE_APPROVAL = 'preApproval';
Icons.ARCHIVE = 'archive';
Icons.BACK = 'back';
Icons.TRANSACTION = 'transaction';
Icons.TAXES = 'taxes';
Icons.INSURANCE = 'insurance';
Icons.FINANCIAL = 'finances';
Icons.LEGAL = 'legal';
Icons.MAINTENANCE = 'maintenance';
Icons.MISC = 'misc';
Icons.MISC_2 = 'misc2';
Icons.DOTS = 'dots';
Icons.DOWNLOAD = 'download';
Icons.SHARE = 'share';
Icons.EDIT = 'edit';
Icons.DELETE = 'delete';
Icons.TABLE_VIEW = 'tableView';
Icons.GRID_VIEW = 'gridView';
Icons.DOCUMENT_1 = 'doc1';
Icons.DOCUMENT_2 = 'doc2';
Icons.DOCUMENT_3 = 'doc3';
Icons.VIEW = 'view';
Icons.SHARE_APP_MSG = 'share-via-appmsg';
Icons.DOCUMENT_SOLID = 'solid-document';
